import React from 'react';

interface EditProfileProps {}
export const EditProfile: React.FC<EditProfileProps> = () => {
  return (
    <div className="profile-edit">
    </div>
  );
};
